/* eslint no-console: ["error", { allow: ["warn", "error"] }] */
import {
  mutationNames
} from '@/store/storeKeysettings'

import * as util from '@/modules/util/util'

import * as moduleconfig from '@/config/moduleConfig'

import { IsNullOrEmpty, getChatUserLocalId, IsDevSim, convertBoolean } from '@/modules/helper/index'

// import { ConstPaths } from '../../config/pathConfig'

// import { HashCodeFromInt } from '../../modules/helper/index'

const state = {
  AppConfig: {
    'AppName': '',
    'MBCClientId': null,
    'AppLanguage': 'EN',
    'Subscription_Id': 0,
    'SubscriptionLevel_Id': 0,
    'Subscription_GUID': '',
    'DateTimeFormat': 'dd/MM/yyyy HH:mm',
    'WhiteLabel': false,
    'AppVersion': 0.1,
    'Urls': {
      'WebAPIURL': 'https://devf7_designer_api.app-controller.net',
      'ContentBaseUrl': 'https://devf7_apps.app-controller.net',
      'DesignAssetsBaseUrl': '',
      'ContentAssetsBaseUrl': ''
    },
    'MainMenu': {
      'MainMenuLayout': 0,
      'BackgroundMode': 0,
      'BackgroundImage': '',
      'Content': null,
      'ContentScrollable': true,
      'MenuItemFontName': '',
      'MenuItemFontColor': '',
      'MenuItemAlignment': 0,
      'MenuItemContainerOpacity': 0,
      'MenuItemOverflowIcon': null,
      'MenuItemOverflowLabel': null,
      'MenuItemOverflowIconOutlined': false,
      'MenuItemOverflowBackgroundColor': 0,
      'TitleBarVisible': true,
      'TitleBarTitle': '',
      'TitleBarFontName': '',
      'TitleBarFontColor': '',
      'TitleBarTitleMode': false,
      'TitleBarOpacity': 0,
      'AppDefaultFont_Id': 0,
      'AppDefaultFont': '',
      'LegalInformation': null
    },
    'DesignSettings': {
      'BackgroundThemeMode': 0,
      'BackgroundColor': 0,
      'BackgroundColorElements': 0,
      'BackgroundImage': null,
      'BackgroundImageOpacity': 0,
      'AppThemeColor': 0,
      'AppThemeFontColor': 0,
      'AppThemeSecondaryFontColor': 0,
      'TitleBarFontName': '',
      'TitleBarFontColor': 0,
      'TitleBarOpacity': 0,
      'AppDefaultFont_Id': 0,
      'AppDefaultFont': ''
    },
    'Fonts': [],
    'Modules': {
      'Items': []
    },
    'IsPhonegap': false,
    'IsInIframe': false,
    'IsInAppPreviewer': false,
    'LastSyncTime': null,
    'AppGUID': ''
  },
  loading: true,
  selectedDevice: 'devsimiPhone6',
  moreMenuIcon: 'more.svg',
  activeModule: '/home-view',
  isStartpage: false,
  sidePanelActive: false,
  panelValue: '',
  Devsimloaded: false
}

const mutations = {
  [mutationNames.SET_APPCONFIG](state, AppConfig) {
    state.AppConfig = Object.assign({}, state.AppConfig, AppConfig)
    state.AppConfig.IsPhonegap = util.isPhoneGap()
    state.AppConfig.IsInIframe = util.isInIframe()
    state.AppConfig.IsInAppPreviewer = util.isInAppPreviewer()
  },
  [mutationNames.SET_DESIGN_SETTINGS](state, payload) {
    state.AppConfig.DesignSettings = payload
  },
  [mutationNames.SET_START_PAGE](state, payload) {
    state.AppConfig.MainMenu = payload
  },
  [mutationNames.SET_SUBSCRIPTIONS_MODULES](state, payload) {
    payload.Items = payload.Items.filter(m => convertBoolean(m.HideModule) === false && convertBoolean(m.RowDeleted) === false)
    state.AppConfig.Modules = payload
  },
  [mutationNames.SET_ACTIVE_MODULE](state, payload) {
    state.activeModule = payload
  },
  [mutationNames.SET_DEVSIM_LOADED](state, payload) {
    state.Devsimloaded = payload
  },
  [mutationNames.SET_PDFDATA](state, payload) {
    state.Pdf = payload
  },
  setMoreMenu(state, payload) {
    state.moreMenuIcon = payload
  },
  setLoading(state, loading) {
    state.loading = loading
  },
  setStartPage(state, payload) {
    state.isStartpage = payload
  },
  setActiveDevice(state, payload) { // only for devsim
    state.selectedDevice = payload
  },
  notification(state, notificationData) {
    this.$router.push({path: notificationData.NavigationUrl})
  },
  setSidePanelActive(state, payload) { // only for Side Menu Panel for main menu layout 2
    state.sidePanelActive = payload
  },
  setPanelValue(state, payload) { // only for Side Menu Panel for main menu layout 2 close in notification
    state.panelValue = payload
  },
  [mutationNames.SHOW_APPPREVIEWER_LINK](state) { }
}

const actions = {
  initAppConfig: ({
    commit
  }, AppConfig) => {
    commit(mutationNames.SET_APPCONFIG, AppConfig)
  },
  showLoader({
    commit
  }) {
    commit('setLoading', true)
  },
  hideLoader({
    commit
  }) {
    commit('setLoading', false)
  },
  setStartPage({
    commit
  }, payload) {
    commit('setStartPage', payload)
  },
  setSidePanelActive({
    commit
  }, payload) {
    commit('setSidePanelActive', payload)
  },
  setPanelValue({
    commit
  }, payload) {
    commit('setPanelValue', payload)
  },
  setActiveModule({
    commit
  }, payload) {
    commit(mutationNames.SET_ACTIVE_MODULE, payload)
  },
  setDevsimloaded({
    commit
  }, payload) {
    commit(mutationNames.SET_DEVSIM_LOADED, payload)
  }
}

const getters = {
  Devsimloaded : state => {
    return state.Devsimloaded
  },
  AppConfig: state => {
    return state.AppConfig
  },
  Modules: state => {
    return state.AppConfig.Modules
  },
  MainMenu: state => {
    return state.AppConfig.MainMenu
  },
  DateTimeFormat: state => {
    return state.AppConfig.DateTimeFormat
  },
  WhiteLabel: state => {
    return state.AppConfig.WhiteLabel
  },
  IsPhonegap: state => {
    return state.AppConfig.IsPhonegap
  },
  IsInIframe: state => {
    return state.AppConfig.IsInIframe
  },
  IsInAppPreviewer: state => {
    return state.AppConfig.IsInAppPreviewer
  },
  AppLanguage: state => {
    return state.AppConfig.AppLanguage
  },
  Subscription_Id: state => {
    return state.AppConfig.Subscription_Id
  },
  loading: state => state.loading,
  MainMenuLayout: state => {
    return parseInt(state.AppConfig.MainMenu.MainMenuLayout)
  },
  AppGUID: state => state.AppGUID,
  MainMenuList: (state, rootGetters) => {
    let modulesItems = [ ...state.AppConfig.Modules.Items ]
    let clone = modulesItems.map(item => {
      return Object.assign({}, item)
    })
    let items = clone.map(item => {
      moduleconfig.default.forEach(module => {
        if (item.BasedOnModule_Id != null && item.BasedOnModule_Id === 12 && (item.Module_Id === 1 || item.Module_Id === 2 || item.Module_Id === 20) && item.Module_Id === module.moduleId) {
          item.url = module.moduleName
        } else {
          if (item.BasedOnModule_Id != null && item.BasedOnModule_Id === module.moduleId && !item.url) {
            item.url = module.moduleName
          } else if (item.BasedOnModule_Id === null && item.Module_Id === module.moduleId) {
            item.url = module.moduleName
          }
        }
      })
      if (item.MenuIcon) {
        if (item.MenuIcon.substring(0, 4) === 'http') {
          item.MenuIcon = item.MenuIcon
        } else {
          item.MenuIcon = state.AppConfig.Urls.ContentAssetsBaseUrl + item.MenuIcon
        }
      }
      // console.log('item',item)
      return item
    })
    items.sort(function(a, b) { return a.OrderId - b.OrderId })
    items.map(x => {
      if(x.Module_Id === 39 && !IsDevSim()) {
        var channelMsgObj = rootGetters.ChannelmsgCount
        //console.log('rootGetters.ChannelmsgCount', rootGetters.ChannelmsgCount)
        if(!IsNullOrEmpty(getChatUserLocalId(state.AppConfig.Subscription_Id))) {
          let count = channelMsgObj.filter(y => y.subscriptionModuleId === x.Id && y.subscriptionId === state.AppConfig.Subscription_Id).reduce((accumulator, currentValue) => accumulator + currentValue.count, 0)
          //console.log('message count',count)
          if (count) {
            x.UnreadChatMessageCount = count
          } else {
            x.UnreadChatMessageCount = 0
          }
        } else {
          x.UnreadChatMessageCount = 0
        }
      }
      return x
    })
    //console.log('items', items)
    return items
  },
  DesignSettings: state => {
    return state.AppConfig.DesignSettings
  },
  AppURLs: state => {
    return state.AppConfig.Urls
  },
  MoreMenuIconURL: state => {
    let icon
    if (state.AppConfig.MainMenu.MenuItemOverflowIcon) {
      if (state.AppConfig.MainMenu.MenuItemOverflowIcon.substring(0, 4) === 'http') {
        icon = state.AppConfig.MainMenu.MenuItemOverflowIcon
      } else {
        icon = state.AppConfig.Urls.ContentAssetsBaseUrl + state.AppConfig.MainMenu.MenuItemOverflowIcon
      }
    }
    return icon
  },
  ActiveModule: state => {
    return state.activeModule
  },
  IsStartpage: state => {
    return state.isStartpage
  },
  SidePanelActive: state => {
    return state.sidePanelActive
  },
  panelValue: state => {
    return state.panelValue
  }
}
export default {
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/appconfig.js